import * as React from 'react'

import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import Button from '@mui/material/Button'
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridRowId
} from '@mui/x-data-grid'
import Select, { SelectChangeEvent } from '@mui/material/Select'

import Magnify from 'mdi-material-ui/Magnify'
import FileDocumentOutline from 'mdi-material-ui/FileDocumentOutline'
import {
  Alert,
  Autocomplete,
  Box,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormHelperText,
  IconButton,
  Slide,
  Stack,
  styled,
  Switch,
  Tooltip
} from '@mui/material'

import { useForm, Controller, Control, FieldErrors } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
  getVariantReports,
  Reports,
  ReportsVariants,
  fetchAnalysisVariantDetails,
  deleteVariantReports,
  editVariantReports,
  fetchVariantDetails,
  VariantDetail
} from '@/@core/services/app.service'
import { useTranslation } from 'react-i18next'
import {
  formatVariantInheritance,
  isJson,
  switchACMG,
  unique
} from '@/@core/utils/utils'
import { judgeAcmg } from '@/@core/layouts/utils'
import { Close, Delete, PencilBox } from 'mdi-material-ui'
import CloseIcon from '@mui/icons-material/Close'
import { TransitionProps } from '@mui/material/transitions'
import { useMutation, useQuery } from 'react-query'
import { useRouter } from 'next/router'
import AntdTables, {
  ColumnTypes,
  DragHandle
} from '@/@core/components/tables-antd'
import { NObject } from '@/@core/components/filter-variants'
import { highRisk, lowRisk, mediumRisk, noRisk } from '../CurrentRepoet'
import { getACMG } from '@/views/analyze/ACMG/ACMGClassification'
import { useDropzone } from 'react-dropzone'
import { itemsEqual } from '@dnd-kit/sortable/dist/utilities'
import { getVariantId } from '.'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    maxWidth: 'none'
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

const schema = yup.object().shape({
  name: yup.string().required(),
  templatePath: yup.string().required(),
  result: yup.string().required()
})

interface Props {
  control: Control<
    {
      name: string
      templatePath: string
      result: 'positive' | 'negative'
    },
    any
  >
  errors: FieldErrors<{
    name: string
    templatePath: string
    result: 'positive' | 'negative'
  }>
  getReportsVariants: any
}

export const handleSetVlaue = (value: NObject) => {
  let normal = false
  let low = false
  let medium = false

  Object.keys(value).map((key) => {
    const temp = value[key]

    if (temp.value === -1) {
      low = true
    } else if (temp.value === 0) {
      medium = true
    } else {
      normal = true
    }
  })

  //

  return low ? 'low' : medium ? 'medium' : 'normal'
}

export const handleSetVlaue2 = (value: NObject) => {
  const str = Object.keys(value)
    .map((key) => {
      const temp = value[key]

      return `${temp.key}_${temp.label}`
    })
    .join('/')

  if (noRisk.find((item) => item === str)) {
    return 'no risk'
  } else if (lowRisk.find((item) => item === str)) {
    return 'low risk'
  } else if (mediumRisk.find((item) => item === str)) {
    return 'medium risk'
  } else if (highRisk.find((item) => item === str)) {
    return 'high risk'
  } else return ''
}

const FormReport = React.forwardRef((props: Props, ref) => {
  const { t, i18n } = useTranslation()
  const router = useRouter()

  const { id } = router.query

  const UploadBase = (props: any) => {
    const { t } = useTranslation()

    // ** Hooks
    const { getRootProps, getInputProps } = useDropzone({
      onDrop: (acceptedFiles: File[]) => {
        if (acceptedFiles.length) {
          const keyId = props.keyId

          const file = acceptedFiles[0]

          if (file) {
            const reader = new FileReader()

            //

            reader.onload = (e: any) => {
              setData(
                data.map((i) => {
                  if (i.keyId === keyId) {
                    i.base = e.target.result

                    i.fileName = file.name
                  }

                  return i
                })
              )

              setRowSelection(
                rowSelection.map((i) => {
                  if (i.keyId === keyId) {
                    i.base = e.target.result

                    i.fileName = file.name
                  }

                  return i
                })
              )
            }

            reader.onerror = (error) => {
              console.error('Error reading file:', error)
            }

            reader.readAsDataURL(file) // 读取文件为 Data URL (Base64)
          }
        }
      }
    })

    return (
      <Box>
        <div {...getRootProps({ className: 'dropzone' })}>
          <input id={props.keyId} {...getInputProps()} accept={'.png,.img'} />

          <Button size="small" variant="contained">
            {`sanger${t('upload')}`}
          </Button>
        </div>
      </Box>
    )
  }

  const type = router.asPath.includes('/samples') ? 'sample' : 'analysis'

  const [template, setTemplate] = React.useState('1')
  const [editId, setEditId] = React.useState('')
  const [result, setResult] = React.useState('positive')
  const [isRoh, setIsRoh] = React.useState(true)
  const [isACMGSF, setIsACMGSF] = React.useState(true)
  const [rowSelection, setRowSelection] = React.useState<any[]>([])
  const [commentsOpen, setCommentsOpen] = React.useState(false)
  const [variantDetails, setVariantDetails] = React.useState<VariantDetail[]>()
  const [details, setDetails] = React.useState([
    {
      title: 'Gene detail',
      key: 'GeneDetail',
      value: ''
    },
    {
      title: 'Variant detail',
      key: 'VariantDetail',
      value: ''
    },
    {
      title: 'Diseases Name',
      key: 'DiseasesName',
      value: ''
    },
    {
      title: 'Category name',
      key: 'CategoryName',
      value: ''
    },
    {
      title: 'Category descriptions',
      key: 'CategoryDescriptions',
      value: ''
    },
    {
      title: 'What it means',
      key: 'means',
      value: ''
    },
    {
      title: 'Recommendations',
      key: 'Recommendations',
      value: ''
    },
    {
      title: 'Interpretation',
      key: 'Interpretation',
      value: ''
    },
    {
      title: 'Disease description',
      key: 'DiseaseDescription',
      value: ''
    },
    {
      title: 'Epidemiology',
      key: 'Epidemiology',
      value: ''
    },
    {
      title: 'Genetic contribution',
      key: 'GeneticContribution',
      value: ''
    },
    {
      title: 'Risk Factor',
      key: 'RiskFactor',
      value: ''
    },
    {
      title: 'Lifestyle acttion and preventation',
      key: 'Lifestyle-acttion-and-preventation',
      value: ''
    },
    {
      title: 'Pubmed References',
      key: 'Pubmed-References',
      value: ''
    }
  ])
  const sets = ['FokISet', 'ApaISet', 'BsmISet', 'TaqISet', 'G66567ASet']
  const sets2 = ['C677T', 'A1298C', 'A66G']
  const Sets = {
    // -1较低，0稍低，1正常
    FokISet: [
      {
        key: 'FokI',
        label: 'AA',
        value: 1
      },
      {
        key: 'FokI',
        label: 'AG',
        value: 0
      },
      {
        key: 'FokI',
        label: 'GG',
        value: -1
      }
    ],
    ApaISet: [
      {
        key: 'ApaI',
        label: 'CC',
        value: 1
      },
      {
        key: 'ApaI',
        label: 'CA',
        value: 0
      },
      {
        key: 'ApaI',
        label: 'AA',
        value: -1
      }
    ],
    BsmISet: [
      {
        key: 'BsmI',
        label: 'CC',
        value: 1
      },
      {
        key: 'BsmI',
        label: 'CT',
        value: 0
      },
      {
        key: 'BsmI',
        label: 'TT',
        value: -1
      }
    ],
    TaqISet: [
      {
        key: 'TaqI',
        label: 'AA',
        value: 1
      },
      {
        key: 'TaqI',
        label: 'AG',
        value: 0
      },
      {
        key: 'TaqI',
        label: 'GG',
        value: -1
      }
    ],
    G66567ASet: [
      {
        key: 'G66567A',
        label: 'CC',
        value: 1
      },
      {
        key: 'G66567A',
        label: 'CT',
        value: 0
      },
      {
        key: 'G66567A',
        label: 'TT',
        value: -1
      }
    ]
  } as NObject
  const Sets2 = {
    C677T: [
      {
        key: 'MTHFR',
        label: 'CC',
        value: 'C677T'
      },
      {
        key: 'MTHFR',
        label: 'CT',
        value: 'C677T'
      },
      {
        key: 'MTHFR',
        label: 'TT',
        value: 'C677T'
      }
    ],
    A1298C: [
      {
        key: 'MTHFR',
        label: 'AA',
        value: 'A1298C'
      },
      {
        key: 'MTHFR',
        label: 'AC',
        value: 'A1298C'
      },
      {
        key: 'MTHFR',
        label: 'CC',
        value: 'A1298C'
      }
    ],
    A66G: [
      {
        key: 'MTRR',
        label: 'AA',
        value: 'A66G'
      },
      {
        key: 'MTRR',
        label: 'AG',
        value: 'A66G'
      },
      {
        key: 'MTRR',
        label: 'GG',
        value: 'A66G'
      }
    ]
  } as NObject

  const ThalassemiaOptions = [
    {
      Mutation: '-α4.2',
      chromPos: 'chr16:220220-223721'
    },
    {
      Mutation: '--THA1',
      chromPos: 'chr16:199861-233310'
    },
    {
      Mutation: '-α2.4',
      chromPos: 'chr16:225996-228381 '
    },
    {
      Mutation: '--SEA',
      chromPos: 'chr16:215396-234699'
    },
    {
      Mutation: '-α3.7',
      chromPos: 'chr16:223462-227311'
    }
  ]

  const [setValue, setSetValue] = React.useState<NObject>({
    FokISet: {
      key: 'FokI',
      label: 'AA',
      value: 1
    },
    ApaISet: {
      key: 'ApaI',
      label: 'CC',
      value: 1
    },
    BsmISet: {
      key: 'BsmI',
      label: 'CC',
      value: 1
    },
    TaqISet: {
      key: 'TaqI',
      label: 'AA',
      value: 1
    },
    G66567ASet: {
      key: 'G66567A',
      label: 'CC',
      value: 1
    }
  })

  const [setValue2, setSetValue2] = React.useState<NObject>({
    C677T: {
      key: 'MTHFR',
      label: 'CC',
      value: 'C677T'
    },
    A1298C: {
      key: 'MTHFR',
      label: 'AA',
      value: 'A1298C'
    },
    A66G: {
      key: 'MTRR',
      label: 'AA',
      value: 'A66G'
    }
  })

  const [thalassemia, setThalassemia] = React.useState({
    HBA1x: [],
    HBA1y: [],
    HBA2x: [],
    HBA2y: [],
    HBB: []
  })
  const pagination = {
    pageNum: 0,
    pageSize: 10
  }
  const [page, setPage] = React.useState(pagination)

  const { refetch: reportsVariantsRefetch } = useQuery<{
    list: ReportsVariants[]
  }>({
    queryKey: ['reportsVariants', id],
    queryFn: () => getVariantReports({ objectId: id, objectType: type } as any),
    keepPreviousData: true,
    onSuccess: async (data: any) => {
      if (data.list && data.list.length) {
        const list = unique(
          data.list[0].snvVariants.map((items: any, index: number) => {
            items.keyId = getVariantId(items)
            items._id = getVariantId(items)

            const omim_phenotypes = items.omim_phenotypes
              ? items.omim_phenotypes
              : items.omim_genes
              ? items.omim_genes.map((item: any) => item.omim_phenotypes).flat()
              : []

            const OMIMData = items.OMIM?.omimData
              ? items.OMIM?.omimData
              : omim_phenotypes
              ? omim_phenotypes
              : []
            const oldOMIMData = OMIMData.map((item: any) => {
              const inheritances: string[] = []
              const clinicalSynopsiss = isJson(item.clinical_synopsis)
                ? JSON.parse(item.clinical_synopsis)
                : item.clinicalSynopsis

              //

              if (
                item &&
                clinicalSynopsiss &&
                clinicalSynopsiss.INHERITANCE &&
                Array.isArray(clinicalSynopsiss.INHERITANCE)
              ) {
                clinicalSynopsiss.INHERITANCE.forEach((str: string) =>
                  inheritances.push(str.toLowerCase())
                )
                const inheritance = formatVariantInheritance(
                  Array.from([...new Set(inheritances)]).join(',')
                )

                item.inheritance =
                  inheritance || inheritance !== ''
                    ? inheritance
                    : Array.from([
                        ...new Set(clinicalSynopsiss.INHERITANCE)
                      ]).join(',')
              }

              return item
            })
            const omim_curate_phenotypes = items.omim_curate_phenotypes
              ? items.omim_curate_phenotypes
              : items.omim_genes
              ? items.omim_genes
                  .map((item: any) => item.omim_curate_phenotypes)
                  .flat()
              : []
            const newOMIMData = items.OMIM?.geneDiseaseTranslated?.data
              ? items.OMIM?.geneDiseaseTranslated?.data
              : omim_curate_phenotypes
              ? omim_curate_phenotypes
              : []

            return {
              ...items,
              type: t(items.variantsType),
              ReportVariantsId: data.list[0].id,
              id: items.id ? items.id : index,
              oldOMIMData: oldOMIMData
                .map((item: any) => {
                  return {
                    ...item,
                    keyid: `${items.gene}_${items.keyId}_${
                      items.variantsType
                    }-${item.pheno_name ?? item.phenoName}`,
                    isChecked: true
                  }
                })
                .filter((item: any) => item),
              newOMIMData: newOMIMData
                .map((item: any) => {
                  return {
                    ...item,
                    keyid: `${items.gene}_${items.keyId}_${items.variantsType}-${item.disease}`,
                    isChecked: true
                  }
                })
                .filter((item: any) => item)
            }
          }),
          'keyId'
        )

        //

        // const details = await Promise.all(
        //   list.map(async (temp) => {
        //     const param = {
        //       chrom: temp.chrom,
        //       pos: temp.pos,
        //       REF: temp.REF,
        //       ALT: temp.ALT,
        //       gene: temp.gene
        //     }

        //     return await getVariantDetails.mutateAsync(param)
        //   })
        // )

        // setVariantDetails(details)

        setData(list)
      } else setData([])
    }
  })

  const deleteReportsVariant = useMutation({
    mutationFn: async (data: number) => await deleteVariantReports(data),
    onSuccess: (data) => {
      //post返回的结果
      reportsVariantsRefetch()
      props.getReportsVariants()
    }
  })

  const editReportVariant = useMutation({
    mutationFn: async (data: ReportsVariants) => await editVariantReports(data),
    onSuccess: (data: ReportsVariants) => {
      //post返回的结果
      // refetch()
      reportsVariantsRefetch()
      if (id && type)
        props.getReportsVariants.mutateAsync({
          objectId: id as string,
          objectType: type
        })

      //
    }
  })

  const getVariantDetails = useMutation({
    mutationFn: async (data: any) => {
      const variants = {
        chrom: data.chrom,
        pos: data.pos,
        REF: data.REF,
        ALT: data.ALT,
        gene: data.gene,
        genomeBuild: 'hg19'
      }

      if (type === 'sample')
        return await fetchVariantDetails({
          sampleId: id as unknown as number,
          variants
        })
      else {
        const analysisItemType = localStorage.getItem('analysisItemType')

        return await fetchAnalysisVariantDetails({
          analysisId: id as unknown as number,
          variants: {
            ...variants,
            analysisItemType
          }
        })
      }
    }
  })

  const [data, setData] = React.useState<any[]>([])

  const handleChange = (event: SelectChangeEvent) => {
    setTemplate(event.target.value)
  }

  const handleSave = () => {
    const editDetails = details.filter((item) => item.value)

    const temp = data.find((item) => item._id === editId)

    if (temp) {
      editDetails.map((items) => {
        temp[items.key] = items.value
      })

      const params: ReportsVariants = {
        id: temp.ReportVariantsId,
        objectId: id as unknown as number,
        objectType: type as any,
        snvVariants: JSON.stringify(data),
        cnvVariants: null,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      editReportVariant.mutateAsync(params)
    }

    //
  }

  const handleRemove = (reportId: number, _id: string) => {
    if (data.length === 1) {
      deleteReportsVariant.mutateAsync(reportId)
    } else {
      const params: ReportsVariants = {
        id: reportId,
        objectId: id as unknown as number,
        objectType: type as any,
        snvVariants: JSON.stringify(data.filter((item) => item._id !== _id)),
        cnvVariants: null,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      editReportVariant.mutateAsync(params)
    }

    // deleteReportsVariant.mutateAsync(id)
  }

  const columns: (ColumnTypes[number] & {
    editable?: boolean
    dataIndex: string
    valueOptions?: { label: string; value: string }[]
    editType?: 'input' | 'select'
  })[] = React.useMemo(() => {
    return [
      {
        key: 'sort',
        dataIndex: 'sort',
        align: 'center',
        width: 80,
        render: () => <DragHandle />
      },
      {
        title: t('gene'),
        dataIndex: 'gene',
        key: 'gene',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Tooltip title={row.gene}>
              <Typography
                sx={{
                  maxWidth: 120,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  textAlign: 'center'
                }}
              >
                {row.gene}
              </Typography>
            </Tooltip>
          )
        }
      },
      {
        title: t('Base change'),
        dataIndex: 'nuc_change',
        key: 'nuc_change',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Stack width={'100%'} direction="column" spacing={1}>
              <Typography>
                {row.chrom && row.pos
                  ? `${row.chrom}:${row.pos}:${
                      row.nuc_change ?? `${row.ref}>${row.alt}`
                    }`
                  : row.variant && row.variant.chrom && row.variant.pos
                  ? `${row.variant.chrom}:${row.variant.pos}`
                  : row.variant && row.variant.chrom && row.variant.start
                  ? `${row.variant.chrom}:${row.variant.start}-${row.variant.end}`
                  : ''}
              </Typography>

              <Typography>
                {row.chrom && row.SV_start
                  ? `${row.chrom}:${row.SV_start}:${row.SV_end}`
                  : ''}
              </Typography>

              <Typography>{row.dbSNP_IDs ? `${row.dbSNP_IDs}` : ''}</Typography>

              <Typography>
                {row.variant && row.variant.type ? `${row.variant.type}` : ''}
              </Typography>
            </Stack>
          )
        }
      },
      {
        title: t('Homozygosity/Coverage'),
        dataIndex: 'coverage',
        key: 'coverage',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Stack width={'100%'} direction="column" spacing={1}>
              <Typography>{value ?? row.ad}</Typography>
            </Stack>
          )
        }
      },
      {
        title: t('gAD (ALL, AFR,AMR)'),
        dataIndex: 'gAD',
        key: 'gAD',
        align: 'center',
        render: (value, row: any) => {
          return (
            <Stack width={'100%'} direction="column" spacing={1}>
              <Typography>
                {row.gnomAD_exome_ALL
                  ? `${row.gnomAD_exome_ALL}`
                  : row.gnomade_af
                  ? `${row.gnomade_af}`
                  : ''}
              </Typography>

              <Typography>
                {row.gnomAD_exome_AFR
                  ? `${row.gnomAD_exome_AFR}`
                  : row.gnomade_eaf_af
                  ? `${row.gnomade_eaf_af}`
                  : ''}
              </Typography>

              <Typography>
                {row.gnomAD_exome_AMR ? `${row.gnomAD_exome_AMR}` : ''}
              </Typography>
            </Stack>
          )
        }
      },
      {
        title: t('grading'),
        dataIndex: 'ACMG_classification',
        key: 'ACMG_classification',
        align: 'center',
        render: (value, row: any) => {
          const classification = judgeAcmg(
            row.user_acmg_classification
              ? row.user_acmg_classification
              : row.acmg_classification
              ? switchACMG(row.acmg_classification)
              : row.ACMG_classification
              ? row.ACMG_classification
              : row.classification
              ? row.classification
              : null
          )

          return (
            <Stack width={'100%'} direction="column" spacing={1}>
              <Typography>{`${classification}`}</Typography>
            </Stack>
          )
        }
      },
      {
        title: t('type'),
        dataIndex: 'type',
        key: 'type',
        align: 'center',
        editable: true,
        editType: 'select',
        valueOptions: [
          {
            label: t('KeyFinding'),
            value: 'KeyFinding'
          },
          {
            label: t('IncidentalDiscovery'),
            value: 'IncidentalDiscovery'
          },
          {
            label: t('CarrierScreening'),
            value: 'CarrierScreening'
          },
          {
            label: t('ACMGDiscovery'),
            value: 'ACMGDiscovery'
          }
        ],
        render: (value) => {
          return (
            <Stack width={'100%'} direction="column" spacing={1}>
              <Typography>{t(value)}</Typography>
            </Stack>
          )
        }
      },
      {
        title: t('OMIM'),
        dataIndex: 'OMIM_zh',
        key: 'OMIM_zh',
        align: 'center',
        editType: 'select',
        render: (value, row: any) => {
          return (
            <Stack width={'100%'} direction="column" spacing={1}>
              {i18n.language === 'zh' ? (
                <Box>
                  {row.newOMIMData?.map((i: any, index: number) => (
                    <Stack direction={'row'} alignItems="center">
                      <Checkbox
                        defaultChecked={i.isChecked}
                        onChange={() => {
                          const newData = data.map((j) => {
                            if (j.keyId === row.keyId) {
                              j.newOMIMData[index].isChecked = !i.isChecked
                            }

                            return j
                          })

                          //

                          // setData(newData)
                        }}
                      />

                      <Typography key={i.disease}>
                        {`${i.disease}--${i.genetic_mode}`}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              ) : (
                <Box>
                  {row.oldOMIMData?.map((i: any, index: number) => (
                    <Stack direction={'row'} alignItems="center">
                      <Checkbox
                        defaultChecked={i.isChecked}
                        onChange={() => {
                          const newData = data.map((j) => {
                            if (j.keyId === row.keyId) {
                              j.oldOMIMData[index].isChecked = !i.isChecked
                            }

                            return j
                          })
                          setData(newData)
                        }}
                      />

                      <Typography key={i.pheno_name ?? i.phenoName}>
                        {`${i.pheno_name ?? i.phenoName}--${i.inheritance}`}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              )}
            </Stack>
          )
        }
      },
      {
        title: t('actions'),
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        render: (value, row: any) => (
          <Stack
            direction={row.base ? 'column' : 'row'}
            alignItems="center"
            justifyContent={'center'}
            spacing={2}
          >
            <IconButton
              size="small"
              onClick={() => {
                handleRemove(row.ReportVariantsId as number, row._id as string)
              }}
            >
              <Delete />
            </IconButton>

            {row.base ? (
              <Stack direction={'row'} alignItems="center">
                <Tooltip title={row.fileName}>
                  <Typography
                    sx={{
                      maxWidth: 130,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {row.fileName}
                  </Typography>
                </Tooltip>

                <IconButton
                  size="small"
                  onClick={() => {
                    setData(
                      data.map((i) => {
                        if (i.keyId === row.keyId) {
                          delete i.base

                          delete i.fileName
                        }

                        return i
                      })
                    )

                    setRowSelection(
                      rowSelection.map((i) => {
                        if (i.keyId === row.keyId) {
                          delete i.base

                          delete i.fileName
                        }

                        return i
                      })
                    )
                  }}
                >
                  <Close />
                </IconButton>
              </Stack>
            ) : template === '6' ||
              template === '7' ||
              template === '8' ||
              template === '9' ||
              template === '10' ? (
              <UploadBase keyId={row.keyId} />
            ) : (
              ''
            )}
          </Stack>
        )
      }
    ] as (ColumnTypes[number] & {
      editable?: boolean
      dataIndex: string
      valueOptions?: { label: string; value: string }[]
      editType?: 'input' | 'select'
    })[]
  }, [i18n, data])
  const defaultValues = {
    name: '',
    templatePath: '1',
    result: 'positive' as 'positive' | 'negative'
  }

  const setsResult = React.useMemo(() => {
    let normal = false
    let low = false
    let medium = false

    Object.keys(setValue).map((key) => {
      const temp = setValue[key]

      if (temp.value === -1) {
        low = true
      } else if (temp.value === 0) {
        medium = true
      } else {
        normal = true
      }
    })

    //

    return low ? 'low' : medium ? 'medium' : 'normal'
  }, [setValue])

  const setsResult2 = React.useMemo(() => {
    const str = Object.keys(setValue2)
      .map((key) => {
        const temp = setValue2[key]

        return `${temp.key}_${temp.label}`
      })
      .join('/')

    if (noRisk.find((item) => item === str)) {
      return 'no risk'
    } else if (lowRisk.find((item) => item === str)) {
      return 'low risk'
    } else if (mediumRisk.find((item) => item === str)) {
      return 'medium risk'
    } else if (highRisk.find((item) => item === str)) {
      return 'high risk'
    } else return ''
  }, [setValue2])

  React.useEffect(() => {
    const temp = data.find((item) => item._id === editId)

    if (temp) {
      const data = details.map((items) => {
        if (temp[items.key]) items.value = temp[items.key]
        else items.value = ''

        return items
      })

      setDetails(data)
    }
  }, [editId])

  const organizationName = React.useMemo(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')

    if (user && user.organization && user.organization.name)
      return user.organization.name as string
    else return ''
  }, [])

  React.useImperativeHandle(ref, () => {
    return {
      rowSelection,
      setValue: {
        setValue2,
        setValue
      },
      isRoh,
      isACMGSF,
      thalassemia
    }
  })

  return (
    <>
      <Typography fontSize={18}>{t('Create new report')}</Typography>

      <Divider />

      <Grid container>
        <Grid item sx={{ width: '100%', minWidth: 900 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
              <Typography>{t('name')}</Typography>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth sx={{ mb: 4 }}>
                <Controller
                  name="name"
                  control={props.control}
                  rules={{ required: true }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      value={value}
                      onChange={(e) => {
                        onChange(e)
                      }}
                      error={Boolean(props.errors.name)}
                      size="small"
                    />
                  )}
                />

                {props.errors.name && (
                  <FormHelperText sx={{ color: 'error.main' }}>
                    {props.errors.name.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
              <Typography>{t('Select template')}</Typography>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth sx={{ mb: 4 }}>
                <Controller
                  name="templatePath"
                  control={props.control}
                  rules={{ required: true }}
                  render={({ field: { value, onChange } }) => (
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={value}
                      onChange={(e) => {
                        onChange(e)

                        setTemplate(e.target.value)
                      }}
                      fullWidth
                      size="small"
                    >
                      <MenuItem value={'1'}>
                        Defaut template: Genome Light Report Template
                      </MenuItem>

                      {/* <MenuItem value={'2'}>
                        {t('Default template: Chinese report template')}
                      </MenuItem>

                      <MenuItem value={'3'}>
                        GENETIC TESTING ANALYSIS REPORT
                      </MenuItem> */}

                      <MenuItem value={'4'}>{t('携带者筛查模板')}</MenuItem>

                      {(organizationName === 'SuperAdmin' &&
                        (process.env.SYSTEM === 'gls' ||
                          process.env.SYSTEM === 'glslocal')) ||
                      organizationName.includes('科瑞迪') ? (
                        <MenuItem value={'5'}>{t('科瑞迪报告模板')}</MenuItem>
                      ) : (
                        ''
                      )}

                      <MenuItem value={'6'}>
                        {t('基诺莱SNV-Indel模板')}
                      </MenuItem>

                      {/* <MenuItem value={'7'}>{t('圣湘CNV模板')}</MenuItem> */}

                      {(organizationName === 'SuperAdmin' &&
                        (process.env.SYSTEM === 'gls' ||
                          process.env.SYSTEM === 'glslocal')) ||
                      organizationName.includes('云南') ? (
                        <MenuItem value={'8'}>{t('云南家系模板')}</MenuItem>
                      ) : (
                        ''
                      )}

                      {(organizationName === 'SuperAdmin' &&
                        (process.env.SYSTEM === 'gls' ||
                          process.env.SYSTEM === 'glslocal')) ||
                      organizationName.includes('云南') ? (
                        <MenuItem value={'9'}>
                          {t('云南全外报告模板2025 位点模板')}
                        </MenuItem>
                      ) : (
                        ''
                      )}

                      {/* <MenuItem value={'10'}>
                        {t('云南全外报告模板2025 阴性模板')}
                      </MenuItem> */}
                      {(organizationName === 'SuperAdmin' &&
                        (process.env.SYSTEM === 'gls' ||
                          process.env.SYSTEM === 'glslocal')) ||
                      organizationName.includes('重庆') ? (
                        <MenuItem value={'11'}>
                          {t('重庆医科大学附二医院报告模板')}
                        </MenuItem>
                      ) : (
                        ''
                      )}

                      <MenuItem value={'12'}>
                        {t('Carrier screening template')}
                      </MenuItem>

                      {(organizationName === 'SuperAdmin' &&
                        (process.env.SYSTEM === 'gls' ||
                          process.env.SYSTEM === 'glslocal')) ||
                      organizationName.includes('艾吉') ? (
                        <MenuItem value={'13'}>
                          {t('艾吉泰康报告模板')}
                        </MenuItem>
                      ) : (
                        ''
                      )}
                    </Select>
                  )}
                />

                {/* {template === '4' ? (
                  <FormHelperText sx={{ color: 'error.main' }}>
                    <Alert severity="info">
                      {t(
                        'The samples must be of the same sex, in the same sequencing pipeline, and should not be related to each other'
                      )}
                    </Alert>
                  </FormHelperText>
                ) : (
                  ''
                )} */}

                {props.errors.templatePath && (
                  <FormHelperText sx={{ color: 'error.main' }}>
                    {props.errors.templatePath.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>

          {template === '12' || template === '13' ? (
            <React.Fragment>
              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{t('HBA1')}</Typography>
                </Grid>

                <Grid item xs={3.5} mr={2}>
                  <FormControl fullWidth sx={{ mb: 4 }}>
                    <Autocomplete
                      value={thalassemia.HBA1x}
                      onChange={(event: any, newValue: any) => {
                        setThalassemia({
                          ...thalassemia,
                          HBA1x: newValue
                        })
                      }}
                      disableClearable
                      id="controllable-states-demo"
                      options={ThalassemiaOptions.map(
                        (i) => `${i.Mutation}//${i.chromPos}`
                      )}
                      multiple
                      limitTags={1}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={3.5} mr={2}>
                  <FormControl fullWidth sx={{ mb: 4 }}>
                    <Autocomplete
                      value={thalassemia.HBA1y}
                      onChange={(event: any, newValue: any) => {
                        setThalassemia({
                          ...thalassemia,
                          HBA1y: newValue
                        })
                      }}
                      disableClearable
                      id="controllable-states-demo"
                      options={ThalassemiaOptions.map(
                        (i) => `${i.Mutation}//${i.chromPos}`
                      )}
                      multiple
                      limitTags={1}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{t('HBA2')}</Typography>
                </Grid>

                <Grid item xs={3.5} mr={2}>
                  <FormControl fullWidth sx={{ mb: 4 }}>
                    <Autocomplete
                      value={thalassemia.HBA2x}
                      onChange={(event: any, newValue: any) => {
                        setThalassemia({
                          ...thalassemia,
                          HBA2x: newValue
                        })
                      }}
                      disableClearable
                      id="controllable-states-demo"
                      options={ThalassemiaOptions.map(
                        (i) => `${i.Mutation}//${i.chromPos}`
                      )}
                      multiple
                      limitTags={1}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={3.5} mr={2}>
                  <FormControl fullWidth sx={{ mb: 4 }}>
                    <Autocomplete
                      value={thalassemia.HBA2y}
                      onChange={(event: any, newValue: any) => {
                        setThalassemia({
                          ...thalassemia,
                          HBA2y: newValue
                        })
                      }}
                      disableClearable
                      id="controllable-states-demo"
                      options={ThalassemiaOptions.map(
                        (i) => `${i.Mutation}//${i.chromPos}`
                      )}
                      multiple
                      limitTags={1}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </React.Fragment>
          ) : (
            ''
          )}

          {template === '4' ? (
            <React.Fragment>
              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{t('位点输入')}</Typography>
                </Grid>

                {sets.map((item) => {
                  return (
                    <Grid item xs={1.5} key={item} mr={2}>
                      <FormControl fullWidth sx={{ mb: 4 }}>
                        <Autocomplete
                          value={setValue[item]}
                          onChange={(event: any, newValue: any) => {
                            setSetValue({
                              ...setValue,
                              [item]: newValue
                            })
                          }}
                          disableClearable
                          id="controllable-states-demo"
                          options={Sets[item]}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={item.split('S').join(' S')}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  )
                })}

                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{`= ${t(setsResult)}`}</Typography>
                </Grid>
              </Grid>

              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{t('位点输入')}</Typography>
                </Grid>

                {sets2.map((item) => {
                  return (
                    <Grid item xs={1.5} key={item} mr={2}>
                      <FormControl fullWidth sx={{ mb: 4 }}>
                        <Autocomplete
                          value={setValue2[item]}
                          onChange={(event: any, newValue: any) => {
                            setSetValue2({
                              ...setValue2,
                              [item]: newValue
                            })
                          }}
                          disableClearable
                          id="controllable-states-demo"
                          options={Sets2[item]}
                          renderInput={(params) => (
                            <TextField {...params} label={`${item} Set`} />
                          )}
                        />
                      </FormControl>
                    </Grid>
                  )
                })}

                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{`= ${t(setsResult2)}`}</Typography>
                </Grid>
              </Grid>
            </React.Fragment>
          ) : (
            ''
          )}

          {template === '6' || template === '7' ? (
            <>
              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{t('Whether to display roh')}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <FormControl fullWidth sx={{ mb: 4 }}>
                    <Switch
                      checked={isRoh}
                      onChange={(e) => {
                        setIsRoh(e.target.checked)
                      }}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                  <Typography>{t('Whether to display ACMG SF')}</Typography>
                </Grid>

                <Grid item xs={6}>
                  <FormControl fullWidth sx={{ mb: 4 }}>
                    <Switch
                      checked={isACMGSF}
                      onChange={(e) => {
                        setIsACMGSF(e.target.checked)
                      }}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </>
          ) : (
            ''
          )}

          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
              <Typography>{t('Test Result')}</Typography>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth sx={{ mb: 4 }}>
                <Controller
                  name="result"
                  control={props.control}
                  rules={{ required: true }}
                  render={({ field: { value, onChange } }) => (
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={value}
                      onChange={(e) => {
                        setResult(e.target.value)

                        onChange(e)
                      }}
                    >
                      <FormControlLabel
                        value="positive"
                        control={<Radio />}
                        label={t('positive')}
                      />

                      <FormControlLabel
                        value="negative"
                        control={<Radio />}
                        label={t('negative')}
                      />
                    </RadioGroup>
                  )}
                />

                {props.errors.result && (
                  <FormHelperText sx={{ color: 'error.main' }}>
                    {props.errors.result.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>

          {result === 'positive' ? (
            <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
              <Grid item xs={1.5} sx={{ textAlign: 'end', paddingRight: 10 }}>
                <Typography>SNV / INDEL</Typography>
              </Grid>

              <Grid item xs={10.5}>
                <AntdTables
                  rows={data}
                  columns={columns}
                  onRowSelectionModelChange={(value: any) => {
                    //

                    const select = value.map((items: any) =>
                      data.find((item) => item.id === items)
                    )

                    setRowSelection(select)
                  }}
                  processRowUpdate={(row: any, newData: any) => {
                    setData(newData)

                    //

                    const params: ReportsVariants = {
                      id: newData[0].ReportVariantsId,
                      objectId: id as unknown as number,
                      objectType: type as any,
                      snvVariants: JSON.stringify(newData),
                      cnvVariants: null,
                      createdAt: new Date(),
                      updatedAt: new Date()
                    }

                    editReportVariant.mutateAsync(params)
                  }}
                />

                {/* <DataGrid
                  rows={data}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        page: page.pageNum,
                        pageSize: page.pageSize
                      }
                    }
                  }}
                  pageSizeOptions={[5, 10, 20, 100]}
                  checkboxSelection
                  disableColumnMenu
                  onPaginationModelChange={(model: any) => {
                    if (model.pageSize === 8) return

                    setPage({
                      pageNum: model.page,
                      pageSize: model.pageSize
                    })
                  }}
                  onRowSelectionModelChange={(value) => {
                    const select = value.map((items) =>
                      data.find((item) => item.id === items)
                    )

                    setRowSelection(select)
                  }}
                  rowCount={10}
                  rowHeight={80}
                /> */}
              </Grid>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </Grid>

      {/* 编辑 */}

      <BootstrapDialog
        onClose={() => setCommentsOpen(!commentsOpen)}
        aria-labelledby="customized-dialog-title"
        open={commentsOpen}
        TransitionComponent={Transition}
        sx={{ minWidth: 1200, maxWidth: 1400 }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {`${t('Select')} ${t('variant')}`}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setCommentsOpen(!commentsOpen)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ minWidth: 800 }}>
          <Box>
            <Grid container spacing={4}>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={editId}
                    name="radio-buttons-group"
                    onChange={(e) => {
                      setEditId(e.target.value)
                    }}
                  >
                    {data.map((items) => {
                      return (
                        <FormControlLabel
                          key={items._id}
                          value={items._id}
                          control={<Radio />}
                          label={`CHr${items.chrom}:${items.pos}:${items.nuc_change}:${items.gene}`}
                        />
                      )
                    })}
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Divider orientation="vertical" flexItem />

              <Grid item xs={12} md={7.9}>
                <Stack spacing={2}>
                  {/* <DataGrid
                    rows={data.filter((item) => item._id === editId)}
                    columns={columns.filter((item, index) => index <= 4)}
                    disableColumnMenu
                    rowCount={1}
                    autoHeight
                    rowHeight={80}
                    pageSizeOptions={[5]}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 1
                        }
                      }
                    }}
                    rowSelection={false}
                    key={data.length}
                  /> */}

                  <Stack
                    spacing={2}
                    height={300}
                    overflow="auto"
                    padding={'20px 0'}
                  >
                    {details.map((detail) => (
                      <FormControl fullWidth key={detail.title}>
                        <TextField
                          id="filled-textarea"
                          label={detail.title}
                          multiline
                          minRows={4}
                          value={detail.value}
                          onChange={(e) => {
                            setDetails(
                              details.map((items) => {
                                if (items.key === detail.key) {
                                  items.value = e.target.value
                                }

                                return items
                              })
                            )
                          }}
                        />
                      </FormControl>
                    ))}
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Stack direction="row" spacing={4} padding={'10px 0'}>
            <Button
              variant="outlined"
              size="small"
              autoFocus
              onClick={() => setCommentsOpen(!commentsOpen)}
            >
              {t('close')}
            </Button>

            <Button
              variant="contained"
              size="small"
              autoFocus
              onClick={() => {
                handleSave()

                setCommentsOpen(!commentsOpen)
              }}
            >
              {t('save')}
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>
    </>
  )
})

export default FormReport
